import { render, staticRenderFns } from "./wt-paged-table.vue?vue&type=template&id=65fb9323&"
import script from "./wt-paged-table.vue?vue&type=script&lang=js&"
export * from "./wt-paged-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports